/**
 * User Replacer View
 */

define(function(require) {
    'use strict';
    var UserReplacerView = require('replacers/user/user.replacer.view');
    var core = require('core');

    return UserReplacerView.extend({
        subscribe: function() {
            this.listenTo(core, 'auth:login', this.render.bind(this));
        }
    });
});
